import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import { getAction } from '@/api/manage';
import imgUrl from '@/assets/others/index/bg.gif';
export var CheckColMixin = {
  data: function data() {
    return {
      factorSource: [],
      indeterminate: false,
      checkAll: true,
      //   动态列数组
      options: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      // 站点列
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        width: '200px',
        title: '站点',
        fixed: 'left',
        align: 'center',
        customRender: function customRender(text, record, index) {
          return record.attrs.siteName;
        }
      },
      cols: [{
        title: '监测时间',
        align: 'center',
        fixed: 'left',
        width: 150,
        dataIndex: 'dataTime',
        colName: 'data_time'
      }],
      scroll: false,

      /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: {},

      /* 数据源 */
      dataSource: [],
      columns: [],
      allColumns: [],
      selectCol: [],
      isPagination: true,
      isReport: false,

      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },

      /* 排序参数 */
      isorter: {// column: 'createTime',
        // order: 'desc',
      },

      /* table加载状态 */
      loading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getCol(window.sessionStorage.getItem('siteType'));
    window.addEventListener('setItem', function (e) {
      if (e.key == 'siteType') {
        _this.getCol(window.sessionStorage.getItem('siteType'));
      }
    });
    this.queryParam.column = 'data_time';
    this.queryParam.order = 'desc';
  },
  beforeDestroy: function beforeDestroy() {
    if (document.getElementById('texts')) {
      document.getElementById('texts').remove();
    }
  },
  methods: {
    openCol: function openCol() {
      this.$refs.colControl.visible = true;
    },
    // 是否显示水质标准
    getCol: function getCol(st) {
      var _this2 = this;

      this.cols = [{
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 100,
        fixed: 'left',
        customRender: function customRender(text, record, index) {
          return _this2.renderAction(record, index);
        }
      }, // {
      //   title: '审核状态',
      //   align: 'center',
      //   width: 150,
      //   dataIndex: 'status',
      //   colName: 'status',
      //   customRender: (text, record, index) => {
      //     return record.attrs.statusName
      //   }
      // },
      {
        title: '审核时间',
        align: 'center',
        width: 150,
        fixed: 'left',
        dataIndex: 'checkTime',
        colName: 'check_time',
        customRender: function customRender(text, record, index) {
          return record.attrs.checkTime;
        }
      }, {
        title: '审核人',
        align: 'center',
        width: 100,
        fixed: 'left',
        dataIndex: 'userId',
        colName: 'userId',
        customRender: function customRender(text, record, index) {
          return record.attrs.userName;
        }
      }, {
        title: '监测时间',
        align: 'center',
        width: 150,
        fixed: 'left',
        dataIndex: 'dataTime',
        colName: 'data_time'
      }, {
        title: '排放标准',
        align: 'center',
        width: 150,
        fixed: 'left',
        customRender: function customRender(text, record, index) {
          return _this2.renderStatus(record);
        }
      }];
    },
    //环境标准
    renderStatus2: function renderStatus2(record) {
      var h = this.$createElement;

      if (record.attrs.currentStandard) {
        return h("span", {
          "class": "statusText",
          "style": 'background-color:' + record.attrs.currentStandard.color
        }, [record.attrs.currentStandard.title]);
      } else {
        return '';
      }
    },
    // renderAction(record) {
    //   if (record.attrs.status == 1) {
    //     return (
    //       <div>
    //         <a style="color:green" onClick={() => this.handleCheck(record, 2)}>
    //           合格
    //         </a>
    //         <a-divider type="vertical"  />
    //         <a style="color:red" onClick={() => this.handleCheck(record, 3)}>不合格</a>
    //       </div>
    //     )
    //   }
    // },
    renderAction: function renderAction(record, index) {
      var _this3 = this;

      var h = this.$createElement;
      // if (record.attrs.status == 1) {
      var name = record.attrs.status == '0' ? '审核' : '查看';
      return h("div", [h("a", {
        "style": "color:green",
        "on": {
          "click": function click() {
            return _this3.handleAudit(record, index);
          }
        }
      }, [name])]); // }
    },
    //环境标准添加合格与否
    renderStatus3: function renderStatus3(record) {
      var h = this.$createElement;

      if (record.attrs.upStandard) {
        return h("span", {
          "class": "statusText",
          "style": 'background-color:green;margin-left:5px'
        }, ["\u8FBE\u6807"]);
      } else {
        if (record.attrs.upStandard === false) {
          return h("span", {
            "class": "statusText",
            "style": 'background-color:red;margin-left:5px'
          }, ["\u4E0D\u8FBE\u6807"]);
        }
      }
    },
    //排放标准
    renderStatus: function renderStatus(record) {
      var h = this.$createElement;
      // console.log(record)
      var tag = this.renderStatus3(record);

      if (record.attrs.currentStandard) {
        return h("div", [h("span", {
          "class": "statusText",
          "style": 'background-color:' + record.attrs.currentStandard.color
        }, [record.attrs.currentStandard.title]), tag]);
      } else {
        return {
          tag: tag
        };
      } // if (record.attrs.upStandard) {
      //   return (
      //     <span class="statusText" style={'background-color:green'}>
      //       合格
      //     </span>
      //   )
      // } else {
      //   if (record.attrs.upStandard === false) {
      //     return (
      //       <span class="statusText" style={'background-color:red'}>
      //         不合格
      //       </span>
      //     )
      //   }
      // }

    },
    // 渲染列
    renderCol: function renderCol(code, text, record) {
      var _this4 = this;

      var h = this.$createElement;
      var data = record.factor[code] || {
        value: ''
      };
      var check = null != data.check ? h("img", {
        "attrs": {
          "src": imgUrl,
          "title": data.check.message
        },
        "style": "margin:0 0 5px 10px;width:15px;height:15px"
      }) : "";

      if (data.status == '2') {
        return h("span", {
          "class": "redText",
          "on": {
            "click": function click(e) {
              return _this4.getDatas(e, data.raw);
            }
          },
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, check, h("a-icon", {
          "attrs": {
            "type": "arrow-down"
          },
          "style": "float:right"
        })]);
      } else if (data.status == '3') {
        return h("span", {
          "class": "redText",
          "on": {
            "click": function click(e) {
              return _this4.getDatas(e, data.raw);
            }
          },
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, check, h("a-icon", {
          "attrs": {
            "type": "arrow-up"
          },
          "style": "float:right"
        })]);
      } else {
        return h("span", {
          "on": {
            "click": function click(e) {
              return _this4.getDatas(e, data.raw);
            }
          },
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, check]);
      }
    },
    getDatas: function getDatas(e, data) {
      console.log(e, data);

      if (document.getElementById('texts')) {
        document.getElementById('texts').remove();
      }

      var newDiv = document.createElement("div");
      newDiv.id = 'texts';
      newDiv.innerHTML = "<p style='background:#f3f1f1;padding:0 2px;border-radius:5px;letter-spacing:1px;border:1px solid #000;position:fixed;z-index:1000;top:".concat(e.pageY + 2, "px;left:").concat(e.pageX, "px;font-size:15px;color:#4a4a4a'>\u539F\u59CB\u6570\u636E:").concat(data, "</p>");
      var currentDiv = document.getElementById("app");
      currentDiv.appendChild(newDiv);
      setTimeout(function () {
        document.getElementById('texts').remove();
      }, 3000);
    },
    searchQuery: function searchQuery() {
      this.loadData();
    },
    // 动态列变化
    onChange: function onChange() {
      this.indeterminate = !!this.selectCol.length && this.selectCol.length < this.options.length;
      this.checkAll = this.selectCol.length === this.options.length;
      this.changeCol();
    },
    changeCol: function changeCol() {
      var _this5 = this;

      if (this.selectCol.length > 5) {
        this.scroll = {
          x: 200 * this.selectCol.length
        };
      } else {
        this.scroll = false;
      }

      if (!this.columns.every(function (item) {
        return item.dataIndex != 'siteName';
      })) {
        this.columns = _toConsumableArray(this.cols);
        this.columns.splice(1, 0, this.siteColumn);
        this.selectCol.forEach(function (item, i) {
          _this5.allColumns.forEach(function (element) {
            if (item == element.id) {
              _this5.columns.push(element);
            }
          });
        });
      } else {
        this.columns = _toConsumableArray(this.cols);
        this.selectCol.forEach(function (item, i) {
          _this5.allColumns.forEach(function (element) {
            if (item == element.id) {
              _this5.columns.push(element);
            }
          });
        });
      }
    },
    // 全选/反选
    onCheckAllChange: function onCheckAllChange(e) {
      Object.assign(this, {
        selectCol: e.target.checked ? this.options.map(function (item) {
          return item.value;
        }) : [],
        indeterminate: false,
        checkAll: e.target.checked
      });
      this.changeCol();
    },
    //添加删除列，idx有值代表插入，无值代表删除
    spliceColumn: function spliceColumn(col, idx) {
      //debugger
      var tempColumn = this.columns.filter(function (item) {
        return item.dataIndex != col.dataIndex;
      }); //不允许存在dataIndex相同的列

      if (idx) {
        //插入索引位置
        if (tempColumn.length == this.columns.length) {
          //数组长度一样，说明不存在列，直接添加
          this.columns.splice(idx, 0, col);
        }
      } else {
        if (tempColumn.length != this.columns.length) {
          //数组长度不一样，说明存在列，需要删除
          this.columns = tempColumn;
        }
      }
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      this.ipagination = pagination;
      this.loadData();
    },
    // 加载表格
    loadData: function loadData(arg) {
      var _this6 = this;

      this.queryParam.st = window.localStorage.getItem('treeSt') || window.sessionStorage.getItem('siteType');

      if (this.isReport && this.queryParam.scope != '1') {
        return;
      }

      if (this.isReport) {
        this.queryParam.st = window.sessionStorage.getItem('siteType');
      }

      if (!this.queryParam.st && this.queryParam.scope != '1') {
        this.$message.warning('请选择监测系统类型！');
        return;
      }

      this.loading = true;
      var that = this;

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      if (this.isPagination) {
        this.queryParam.current = this.ipagination.current;
        this.queryParam.size = this.ipagination.pageSize;
      }

      getAction(this.url, this.queryParam).then(function (res) {
        if (res.success) {
          that.allColumns = _toConsumableArray(that.cols);
          that.selectCol = [];
          that.options = [];

          if (_this6.isPagination) {
            that.dataSource = res.result.records;
            that.factorSource = res.result.query.factors;
            that.ipagination.total = res.result.total;
            res.result.query.factors.forEach(function (element) {
              that.options.push({
                label: element.title,
                value: element.id
              });
              that.selectCol.push(element.id);
              that.allColumns.push({
                id: element.id,
                title: element.title,
                align: 'center',
                // width: 250,
                children: [{
                  title: element.unitName,
                  align: 'center',
                  // width: 200,
                  dataIndex: element.code,
                  customRender: function customRender(text, record, index) {
                    return that.renderCol(element.code, text, record);
                  }
                }]
              });
            });

            if (that.allColumns.length > 6) {
              that.scroll = {
                x: 200 * that.allColumns.length
              };
            } else {
              that.scroll = false;
            }

            that.columns = _toConsumableArray(that.allColumns);

            if (that.queryParam.scope == '1') {
              that.spliceColumn(that.siteColumn);
            } else if (that.queryParam.scope == '2' || that.queryParam.scope == '3' || that.queryParam.scope == '4') {
              that.spliceColumn(that.siteColumn, 1);
            }
          } else {
            that.factorSource = res.result.query.factors;
            that.dataSource = res.result.records;
            res.result.query.factors.forEach(function (element) {
              that.options.push({
                label: element.title,
                value: element.code
              });
              that.selectCol.push(element.code);
              that.allColumns.push({
                id: element.code,
                title: element.title,
                align: 'center',
                // width: 250,
                children: [{
                  title: element.unitName,
                  align: 'center',
                  // width: 200,
                  dataIndex: element.code,
                  customRender: function customRender(text, record, index) {
                    return that.renderCol(element.code, text, record);
                  }
                }]
              });
            });

            if (that.allColumns.length > 6) {
              that.scroll = {
                x: 200 * that.allColumns.length
              };
            } else {
              that.scroll = false;
            }

            that.columns = _toConsumableArray(that.allColumns);
          }
        } else {
          _this6.$message.warning('系统异常=>' + res.message);
        }

        _this6.loading = false;
      });
    }
  }
};